import { render, staticRenderFns } from "./img-upload.vue?vue&type=template&id=dc79e2d6&scoped=true&"
import script from "./img-upload.vue?vue&type=script&lang=js&"
export * from "./img-upload.vue?vue&type=script&lang=js&"
import style0 from "./img-upload.vue?vue&type=style&index=0&id=dc79e2d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc79e2d6",
  null
  
)

/* custom blocks */
import block0 from "../locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Fquake%2Fworkspace%2Fauction%2Ftokyo-auction-frontend%2Fsrc%2Fviews%2Fmine%2Fcomponents%2Fimg-upload.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports